import MeetingSummaryEdit from './MeetingSummaryEdit';

export default MeetingSummaryEdit;
